import {motion} from "framer-motion"
import { useTranslation } from "react-i18next";
import { useScrollSection } from "react-scroll-section";
import "../style/css/ResponsiveMenu.css"

function ResponsiveMenu({handleMenuOpen}) {

  const home = useScrollSection("home")
  const technologies = useScrollSection("technologies")
  const works = useScrollSection("works")
  const contact = useScrollSection("contact")
  const featured = useScrollSection("featured")

  const { t } = useTranslation(['common']);


  
  const menuVariant = {
    hidden: {
      scale: 0
    },
    visible: {
     scale: 1,
     transition: {
      delay: 0.2,
      staggerChildren: 0.2,
      when: "beforeChildren"
     }
    }
  }

  const listVariant = {
    hidden: {
      x: -50,
      opacity: 0
    },
    visible: {
      x: 0,
      opacity: 1,
      
  }}

   return (
      <motion.div className='responsive-menu'
      variants={menuVariant}
      animate="visible"
      initial="hidden"
      >
        <motion.li 
           variant={listVariant} 
           onClick={() => {home.onClick(); handleMenuOpen()}} 
           selected={home.selected}>
            {t("home")}
        </motion.li>
        <motion.li 
           variant={listVariant} 
           onClick={() => {featured.onClick(); handleMenuOpen()}} 
           selected={featured.selected}>
            {t("featured")}
        </motion.li>
        <motion.li 
           variant={listVariant} 
           onClick={() => {technologies.onClick(); handleMenuOpen()}} 
           selected={technologies.selected}>
            {t("technologies")}
        </motion.li>
        <motion.li 
           variant={listVariant} 
           onClick={() => {works.onClick(); handleMenuOpen()}} 
           selected={works.selected}>
            {t("works")}
        </motion.li>
        <motion.li 
           variant={listVariant} 
           onClick={() => {contact.onClick(); handleMenuOpen()}} 
           selected={contact.selected}>
            {t("contact")}
        </motion.li>
 
      </motion.div>
    )
    
  
}

export default ResponsiveMenu